import Constants from "expo-constants";

declare const __DEV__: boolean;

const getSupabaseUrl = (): string => {
  const hostUri = Constants.expoConfig?.hostUri;

  if (__DEV__ && hostUri) {
    const origin = hostUri.split(":").shift();
    if (!origin) {
      throw new Error("Could not determine origin from hostUri");
    }
    return `http://${origin}:54321`;
  }

  if (!process.env.EXPO_PUBLIC_SUPABASE_URL) {
    throw new Error(
      "EXPO_PUBLIC_SUPABASE_URL is required in production builds"
    );
  }

  return process.env.EXPO_PUBLIC_SUPABASE_URL;
};

export { getSupabaseUrl };

/** Builds a full URL for a storage path (we store paths in the DB, not full URLs). */
export function resolveStorageUrl(url: string | null | undefined): string {
  if (!url || typeof url !== "string") return url ?? "";
  if (url.startsWith("/")) {
    return `${new URL(getSupabaseUrl()).origin}${url}`;
  }
  return url;
}
